import { Component, signal } from '@angular/core';
import { MenuComponent } from '../../shared/menu/menu.component';
import { CommonModule } from '@angular/common';
import { NgScrollbarModule } from 'ngx-scrollbar';

@Component({
  selector: 'app-master-reporting',
  imports: [CommonModule, MenuComponent, NgScrollbarModule],
  templateUrl: './master-reporting.component.html',
  styleUrl: './master-reporting.component.scss'
})
export class MasterReportingComponent {
  menuCollapsed = signal(false);
  bookings = [
    {
      clientName: 'John Smith',
      bookingRef: 'TRV2023-001',
      accManager: 'Sarah Johnson',
      bookDate: new Date('2023-05-15'),
      netPrice: 1200,
      sellingPrice: 1500,
      profit: 300,
      destination: 'Bali, Indonesia',
      hotel: 'The Luxe Resort',
      checkIn: new Date('2023-07-10'),
      nights: 7,
      status: 'Confirmed',
      paid: true,
      room: 'Deluxe Ocean View',
      mode: 'Online',
      supplier: 'Bali Paradise Tours',
      deadline: new Date('2023-06-25'),
      supplierDue: new Date('2023-07-05')
    },
    {
      clientName: 'Emily Chen',
      bookingRef: 'TRV2023-002',
      accManager: 'Michael Brown',
      bookDate: new Date('2023-05-18'),
      netPrice: 850,
      sellingPrice: 1100,
      profit: 250,
      destination: 'Paris, France',
      hotel: 'Champs Élysées Hotel',
      checkIn: new Date('2023-08-22'),
      nights: 5,
      status: 'Confirmed',
      paid: false,
      room: 'Standard Double',
      mode: 'Phone',
      supplier: 'Euro Travel Partners',
      deadline: new Date('2023-08-01'),
      supplierDue: new Date('2023-08-15')
    },
    {
      clientName: 'Robert Williams',
      bookingRef: 'TRV2023-003',
      accManager: 'Sarah Johnson',
      bookDate: new Date('2023-05-20'),
      netPrice: 3200,
      sellingPrice: 4000,
      profit: 800,
      destination: 'Maldives',
      hotel: 'Aqua Paradise Resort',
      checkIn: new Date('2023-09-05'),
      nights: 10,
      status: 'Pending',
      paid: true,
      room: 'Overwater Villa',
      mode: 'Email',
      supplier: 'Island Getaways',
      deadline: new Date('2023-08-20'),
      supplierDue: new Date('2023-08-30')
    },
    {
      clientName: 'Lisa Rodriguez',
      bookingRef: 'TRV2023-004',
      accManager: 'David Wilson',
      bookDate: new Date('2023-05-22'),
      netPrice: 750,
      sellingPrice: 950,
      profit: 200,
      destination: 'Rome, Italy',
      hotel: 'Colosseum View Inn',
      checkIn: new Date('2023-10-12'),
      nights: 4,
      status: 'Confirmed',
      paid: false,
      room: 'Superior Room',
      mode: 'Online',
      supplier: 'Mediterranean Travel',
      deadline: new Date('2023-09-28'),
      supplierDue: new Date('2023-10-05')
    },
    {
      clientName: 'James Taylor',
      bookingRef: 'TRV2023-005',
      accManager: 'Michael Brown',
      bookDate: new Date('2023-05-25'),
      netPrice: 1800,
      sellingPrice: 2200,
      profit: 400,
      destination: 'Tokyo, Japan',
      hotel: 'Sakura Tower',
      checkIn: new Date('2023-11-15'),
      nights: 8,
      status: 'Cancelled',
      paid: true,
      room: 'Executive Suite',
      mode: 'In-Person',
      supplier: 'Asia Travel Network',
      deadline: new Date('2023-10-30'),
      supplierDue: new Date('2023-11-10')
    },
    {
      clientName: 'Sophia Martinez',
      bookingRef: 'TRV2023-006',
      accManager: 'David Wilson',
      bookDate: new Date('2023-05-28'),
      netPrice: 950,
      sellingPrice: 1250,
      profit: 300,
      destination: 'New York, USA',
      hotel: 'Manhattan Grand',
      checkIn: new Date('2023-12-05'),
      nights: 6,
      status: 'Confirmed',
      paid: true,
      room: 'City View Room',
      mode: 'Online',
      supplier: 'American Travel Co',
      deadline: new Date('2023-11-20'),
      supplierDue: new Date('2023-11-30')
    },
    {
      clientName: 'William Anderson',
      bookingRef: 'TRV2023-007',
      accManager: 'Sarah Johnson',
      bookDate: new Date('2023-05-30'),
      netPrice: 2800,
      sellingPrice: 3500,
      profit: 700,
      destination: 'Santorini, Greece',
      hotel: 'Caldera View Suites',
      checkIn: new Date('2023-09-20'),
      nights: 7,
      status: 'Confirmed',
      paid: false,
      room: 'Honeymoon Suite',
      mode: 'Phone',
      supplier: 'Greek Island Tours',
      deadline: new Date('2023-09-05'),
      supplierDue: new Date('2023-09-15')
    }
  ];

  onMenuToggled(isCollapsed: boolean) {
    this.menuCollapsed.set(isCollapsed);
  }
}